// NavbarMenuConfig.js

/**
 * Jedini izvor istine za navigaciju.
 * Desktop i Mobile renderuju isti config, pa nema dupliranja.
 */
export const NAV_ITEMS = [
  {
    id: "admission",
    labelKey: "navbar.Admission",
    to: "/upis",
    // Mobile je ranije imao dodatni link u submenu: mobile.upis -> /upis
    mobileSubmenuLink: { labelKey: "mobile.upis", to: "/upis" },
    children: [
      {
        id: "admission.dates",
        labelKey: "admission.UpisniRokovi",
        to: "/upisni-rokovi",
      },
      {
        id: "admission.fees",
        labelKey: "admission.Skolarina",
        to: "/cijene-studija",
      },
      {
        id: "admission.transfer",
        labelKey: "admission.Prelazak",
        to: "/prelazak-sa-drugih-fakulteta",
      },
      {
        id: "admission.accreditation",
        labelKey: "admission.Akreditacija",
        to: "/akreditacija-fpep",
      },
    ],
  },

  {
    id: "programs",
    labelKey: "navbar.Programs",
    to: "/svi-studijski-programi",
    children: [
      {
        id: "programs.basic",
        labelKey: "programs.osnovne",
        desktopArrow: true,
        children: [
          {
            id: "programs.basic.rfb",
            labelKey: "osnovne.rfb",
            to: "/racunovodstvo-finansije-i-bankarstvo",
          },
          {
            id: "programs.basic.management",
            labelKey: "osnovne.menadzment",
            to: "/menadzment",
          },
          {
            id: "programs.basic.law",
            labelKey: "osnovne.pravo",
            to: "/pravo-osnovne",
          },
        ],
      },
      {
        id: "programs.specialist",
        labelKey: "programs.specijalisticke",
        to: "/specijalisticke-studije",
        // MJS/MPS subrute nijesu obrisane iz projekta.
        // Namjerno su samo sakrivene iz navigacije dok je aktuelan novi model.
        // Ako se poseban upis specijalističkih vrati, vrati children blok iz istorije/gita.
      },
      {
        id: "programs.master",
        labelKey: "programs.master",
        desktopArrow: true,
        children: [
          {
            id: "programs.master.be",
            labelKey: "master.poslovnaEkonomija",
            to: "/poslovna-ekonomija",
          },
          {
            id: "programs.master.pse",
            labelKey: "master.ekonomijaJavnogSektora",
            to: "/ekonomija-javnog-sektora",
          },
          {
            id: "programs.master.law",
            labelKey: "master.pravo",
            to: "/pravo-master",
          },
        ],
      },
    ],
  },

  {
    id: "about",
    labelKey: "navbar.AboutUs",
    children: [
      {
        id: "about.university",
        labelKey: "about.univerzitet",
        to: "/o-univerzitetu",
      },

      {
        id: "about.fpep",
        labelKey: "about.fpep",
        to: "/o-fpep",
        desktopArrow: true,
        // Mobile je ranije imao dodatni link u submenu: mobile.fpep -> /o-fpep
        mobileSubmenuLink: { labelKey: "mobile.fpep", to: "/o-fpep" },
        children: [
          {
            id: "about.fpep.founder",
            labelKey: "fpep.osnivac",
            to: "/osnivac",
          },
          {
            id: "about.fpep.dean",
            labelKey: "fpep.rijecDekana",
            to: "/rijec-dekana",
          },
          {
            id: "about.fpep.mission",
            labelKey: "fpep.misijaVizija",
            to: "/misija-vizija-i-vrijednosti",
          },
          {
            id: "about.fpep.strategy",
            labelKey: "fpep.strategijaRazvoja",
            to: "/strategija-razvoja-fpep-2026-2029",
          },
        ],
      },

      {
        id: "about.staff",
        labelKey: "about.nastavnoOsoblje",
        to: "/nastavno-osoblje",
      },

      {
        id: "about.acts",
        labelKey: "navbar.LegalActs",
        desktopArrow: true,
        children: [
          {
            id: "about.acts.workPermits",
            labelKey: "pravniAkti.dozvole",
            to: "/dozvole-za-rad",
          },
          {
            id: "about.acts.publishing",
            labelKey: "pravniAkti.izdavacka",
            to: "/izdavacka-djelatnost",
          },
          {
            id: "about.acts.research",
            labelKey: "pravniAkti.rad",
            to: "/naucnoistrazivacki-rad",
          },
          {
            id: "about.acts.quality",
            labelKey: "pravniAkti.kvalitet",
            to: "/obezbjedjivanje-kvaliteta",
          },
          {
            id: "about.acts.integrity",
            labelKey: "pravniAkti.integritet",
            to: "/akademski-integritet",
          },
          {
            id: "about.acts.practice",
            labelKey: "pravniAkti.model",
            to: "/model-studentske-prakse",
          },
        ],
      },

      // U tvom desktop kodu je ovo bilo "has-sub" iako nema submenu – ostavljamo isto ponašanje:
      {
        id: "about.faq",
        labelKey: "about.najcescapitanja",
        to: "/najcesca-pitanja",
        forceHasSub: true,
      },
    ],
  },

  {
    id: "intl",
    labelKey: "navbar.InternationalCoop",
    children: [
      { id: "intl.erasmus", labelKey: "saradnja.erasmus", to: "/erasmus" },
      { id: "intl.projects", labelKey: "saradnja.projekti", to: "/projekti" },
      { id: "intl.montenegro", labelKey: "saradnja.cg", to: "/o-crnoj-gori" },
      { id: "intl.bar", labelKey: "saradnja.bar", to: "/o-baru" },
    ],
  },

  {
    id: "students",
    labelKey: "navbar.Students",
    children: [
      {
        id: "students.parliament",
        labelKey: "studenti.parlament",
        to: "/studentski-parlament",
      },
      { id: "students.dorm", labelKey: "studenti.dom", to: "/dom-studenata" },
      {
        id: "students.alumni",
        labelKey: "studenti.alumni",
        to: "/alumni-klub",
      },
    ],
  },

  {
    id: "updates",
    labelKey: "navbar.Aktuelnosti",
    children: [
      {
        id: "updates.summerSchool2026",
        labelKey: "navbar.SummerSchool2026",
        to: "/aktuelnosti/ljetnja-skola-bar-2026",
      },
      { id: "updates.news", labelKey: "navbar.News", to: "/novosti" },
      { id: "updates.gallery", labelKey: "navbar.Gallery", to: "/galerija" },
    ],
  },

  // Desktop ti je ovo imao "has-sub" iako nema submenu – ostavljamo:
  {
    id: "contact",
    labelKey: "navbar.Contact",
    to: "/kontakt",
    forceHasSub: true,
    mobileLiClass: "mean-last",
  },
];
